import React from 'react'
import LandingMainPage from './components/landing/mlo-landing-page'
import KSLoanAppbar from './components/appbar/app-bar'
import Footer from './components/footer/Footer'
import ContactUs from './components/faq/contact-section'
import { Box, Button, Container, Grid, InputLabel, Stack, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Banner from './components/banner/banner'
import SearchMLO from './components/information/search-mlo'
import WhyChoose from './components/information/why-choose'
import Invitation from './components/information/invitation'
import DocCollection from './components/information/doc-collection'
import { Approval } from '@mui/icons-material'
import PreApproval from './components/information/pre-approval'
import InstantMessaging from './components/information/instant-messaging'
import BannerMain from './components/banner/new-banner'



export default function Home() {



    //const classes = useStyles();
    return (
        <div>
            <Box sx={{ backgroundColor: 'icegray' }}>
                <KSLoanAppbar />

                <BannerMain />
                <Container maxWidth="xl">

                    {/* <LandingMainPage /> */}
                    <Invitation />
                    <DocCollection />
                    <PreApproval />
                    <InstantMessaging />
                    <WhyChoose />
                    <SearchMLO />

                    <Box mb={6} mt={4} >
                        <ContactUs />
                    </Box>
                </Container>
                <Footer />
            </Box>
        </div >
    )
}
